import { SocketStatus } from "@services/http/socket/WmSocket";
import { dev } from "@utils/dev";
import { ActionSocket } from "./actionTypes";

export interface ActionSocketUpdateStatus {
  type: ActionSocket,
  payload: SocketStatus,
}

export function updateSocketStatus(value: SocketStatus): ActionSocketUpdateStatus {
  return {
    type: ActionSocket.UpdateStatus,
    payload: value,
  }
}